var _g, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBowlerNotSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#000000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#aaaaaa",
    fill: "#aaaaaa"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,5L19,19",
    stroke: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6,4L6,5M8,6L8,7M10,8L10,9M12,10L12,11M14,12L14,13M16,14L16,15M18,16L18,17",
    stroke: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6L5,6M6,8L7,8M8,10L9,10M10,12L11,12M12,14L13,14M14,16L15,16M16,18L17,18",
    stroke: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBowlerNotSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bowler-not-selected.63e52e40a7dd256a330b81ca9a98a113.svg";